import { Fragment } from "react"
import { toast } from "react-toastify"
import Avatar from "@components/avatar"
import { Bell } from "react-feather"

export const alertCustom = (status, mess) => {
    <>
        <>
            {status === "success" && (toast.success(
                <Fragment>
                    <div className="toastify-header">
                        <div className="title-wrapper">
                            <Avatar size="sm" color="success" icon={<Bell size={12} />} />
                            <h6 className="toast-title">
                                {window.localStorage.getItem("locale") !== "en" ? "Thành công!" : "Success!"}
                            </h6>
                        </div>
                    </div>
                    <div className="toastify-body">
                        <span role="img" aria-label="toast-text">
                            {mess}
                        </span>
                    </div>
                </Fragment>,
                { hideProgressBar: true }
            ))
            }
        </>
        <>
            {status === "error" && (toast.error(
                <Fragment>
                    <div className="toastify-header">
                        <div className="title-wrapper">
                            <Avatar size="sm" color="danger" icon={<Bell size={12} />} />
                            <h6 className="toast-title">
                                {window.localStorage.getItem("locale") !== "en" ? "Lỗi!" : "Error!"}
                            </h6>
                        </div>
                    </div>
                    <div className="toastify-body">
                        <span role="img" aria-label="toast-text">
                            {mess}
                        </span>
                    </div>
                </Fragment>,
                { hideProgressBar: true }
            ))
            }
        </>
        <>
            {status === "warning" && (toast.warning(
                <Fragment>
                    <div className="toastify-header">
                        <div className="title-wrapper">
                            <Avatar size="sm" color="warning" icon={<Bell size={12} />} />
                            <h6 className="toast-title">
                                {window.localStorage.getItem("locale") !== "en" ? "Cảnh báo!" : "Warning!"}
                            </h6>
                        </div>
                    </div>
                    <div className="toastify-body">
                        <span role="img" aria-label="toast-text">
                            {mess}
                        </span>
                    </div>
                </Fragment>,
                { hideProgressBar: true }
            ))
            }
        </>
    </>
}

export const alertCustomInfo = (status, mess) => {

    status === "info" ? toast.info(
        <Fragment>
            <div className="toastify-header">
                <div className="title-wrapper">
                    <Avatar size="sm" color="primary" icon={<Bell size={12} />} />
                    <h6 className="toast-title">
                        {window.localStorage.getItem("locale") !== "en" ? "Thông báo!" : "Info!"}
                    </h6>
                </div>
            </div>
            <div className="toastify-body">
                <span role="img" aria-label="toast-text">
                    {mess}
                </span>
            </div>
        </Fragment>,
        { hideProgressBar: true }
    ) : toast.error(
        <Fragment>
            <div className="toastify-header">
                <div className="title-wrapper">
                    <Avatar size="sm" color="danger" icon={<Bell size={12} />} />
                    <h6 className="toast-title">
                        {window.localStorage.getItem("locale") !== "en" ? "Lỗi!" : "Error!"}
                    </h6>
                </div>
            </div>
            <div className="toastify-body">
                <span role="img" aria-label="toast-text">
                    {mess}
                </span>
            </div>
        </Fragment>,
        { hideProgressBar: true }
    )
}